module.exports = {"TXTWCL_Mobile_Number_Verification":{"id":"TXTWCL_Mobile_Number_Verification","defaultMessage":"Weryfikacja numeru telefonu komórkowego"}}